"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCookieDeclaration = void 0;
var react_1 = require("react");
var CookieDeclarationProvider_1 = require("./CookieDeclarationProvider");
/**
 * Hook to access CookieDeclarationContext.
 *
 * @throws Error: if this hook is used outside CookieDeclarationProvider
 * @see CookieDeclarationProvider
 */
var useCookieDeclaration = function () {
    var context = react_1.useContext(CookieDeclarationProvider_1.CookieDeclarationContext);
    if (!context) {
        throw new Error("Developer Error: useCookieDeclaration must be used inside CookieDeclarationContext");
    }
    return context;
};
exports.useCookieDeclaration = useCookieDeclaration;
